var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.36 16.8636C31.36 15.7291 31.2582 14.6382 31.0691 13.5908H16V19.7799H24.6109C24.24 21.7799 23.1128 23.4745 21.4182 24.6091V28.6236H26.5891C29.6146 25.8382 31.36 21.7363 31.36 16.8636Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9982 32.5C20.3182 32.5 23.94 31.0672 26.5872 28.6237L21.4163 24.6092C19.9837 25.5692 18.1509 26.1364 15.9982 26.1364C11.8309 26.1364 8.30368 23.3218 7.04544 19.54H1.7V23.6855C4.3328 28.9146 9.74368 32.5 15.9982 32.5Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.0472 19.5399C6.7272 18.5799 6.54544 17.5545 6.54544 16.4999C6.54544 15.4453 6.7272 14.4199 7.0472 13.4599V9.31445H1.70176C0.618239 11.4745 0 13.9181 0 16.4999C0 19.0817 0.618239 21.5253 1.70176 23.6853L7.0472 19.5399Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.9982 6.86368C18.3472 6.86368 20.4563 7.67088 22.1146 9.25632L26.7037 4.6672C23.9328 2.08544 20.3109 0.5 15.9982 0.5C9.74368 0.5 4.3328 4.08544 1.7 9.31456L7.04544 13.46C8.30368 9.67824 11.8309 6.86368 15.9982 6.86368Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.ef4a4489a016ed48761daebf5d673c9b.svg";
export { ForwardRef as ReactComponent };